import React from "react";
import { Slider, Rail, Handles, Tracks, Ticks } from "react-compound-slider";
import PropTypes from "prop-types";
import { Handle } from "./Handle/Handle";
import { Track } from "./Track/Track";
import { Tick } from "./Tick/Tick";
import "./CompoundSlider.scss";

export class CompoundSlider extends React.Component {
  static propTypes = {
    /** Additional class names for the component */
    className: PropTypes.string,
    /** Id associated with component */
    id: PropTypes.string.isRequired,
    /** Label associated with component */
    label: PropTypes.string,
    /** Callback function when slider's values are changed */
    onChange: PropTypes.func,
    /** Min value on slider */
    min: PropTypes.number,
    /** Max value on slider */
    max: PropTypes.number,
    /** default values for the ticks start at */
    defaultValues: PropTypes.array,
  };

  constructor(props) {
    super(props);

    let values;
    if (props.defaultValues) {
      values = props.defaultValues;
    } else {
      values = [props.min, props.max];
    }

    this.state = {
      values,
    };

    this.onChange = this.onChange.bind(this);
  }

  onChange(event) {
    const { id, onChange } = this.props;

    this.setState({
      values: event,
    });

    if (onChange) {
      return onChange({
        id,
        value: event,
      });
    }
    return event;
  }

  render() {
    const { id, label, max, min } = this.props;
    const { values } = this.state;

    return (
      <div className="compound-slider">
        {label !== null ? <label htmlFor={id}>{label}</label> : null}
        <Slider
          id={id}
          className="sliderStyle"
          domain={[min, max]}
          step={1}
          mode={2}
          values={values}
          onChange={this.onChange}
        >
          <Rail>
            {({ getRailProps }) => (
              <div className="railStyle" {...getRailProps()} />
            )}
          </Rail>
          <Handles>
            {({ getHandleProps, handles }) => (
              <div className="slider-handles">
                {handles.map((handle) => (
                  <Handle
                    key={handle.id}
                    handle={handle}
                    getHandleProps={getHandleProps}
                  />
                ))}
              </div>
            )}
          </Handles>
          <Tracks left={false} right={false}>
            {({ getTrackProps, tracks }) => (
              <div className="slider-tracks">
                {tracks.map(({ source, target }) => (
                  <Track
                    key={source.id}
                    source={source}
                    target={target}
                    getTrackProps={getTrackProps}
                  />
                ))}
              </div>
            )}
          </Tracks>
          <Ticks values={[min, (min + max) / 2, max]}>
            {({ ticks }) => (
              <div className="slider-ticks">
                {ticks.map((tick) => (
                  <Tick key={tick.id} tick={tick} count={ticks.length} />
                ))}
              </div>
            )}
          </Ticks>
        </Slider>
        <br />
      </div>
    );
  }
}
export default CompoundSlider;
